module.exports = __webpack_public_path__ + "img/app-download-qrcode.94c4578e.png";